import { Typography } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';

const QuizNotMapped = ({ match }) => {
    const carmenQuizTitle = match && match.params && match.params.carmenQuizTitle ? match.params.carmenQuizTitle : null;

    return (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: "translate(-50%, -50%)",
            width:'100%',
            textAlign:'center'
        }}>
            {carmenQuizTitle ?
                <Typography variant={`${isMobile ? 'h6' : 'h5'}`}>
                    Assignment <b>{decodeURIComponent(carmenQuizTitle)}</b> is not mapped with a quiz in Stem Fluency.
                    <br />
                    Please ask your Instructor to do the mapping
                </Typography>
                : <h1>Invalid Request</h1>}
        </div>
    )
}

export default QuizNotMapped;